import { request } from '@@/plugin-request';

export async function queryGradeProtectionPrograms(params) {
  return request('/api/gradeProtectionPrograms', {
    method: 'GET',
    params,
  });
}

export async function createGradeProtectionProgram(payload) {
  return request('/api/gradeProtectionPrograms', {
    method: 'POST',
    data: payload,
  });
}

export async function updateGradeProtectionProgram(id, payload) {
  return request(`/api/gradeProtectionPrograms/${id}`, {
    method: 'PUT',
    data: payload,
  });
}

export async function archiveGradeProtectionProgram(id, payload) {
  return request(`/api/gradeProtectionPrograms/${id}/archive`, {
    method: 'PATCH',
    data: payload,
  });
}

export async function finddefaultStudents(params) {
  return request(`/api/gradeProtectionPrograms/findDefaultStudents`, {
    method: 'GET',
    params,
  });
}
export async function findStudentEnrollments(params) {
  return request(`/api/gradeProtectionPrograms/findStudentEnrollments`, {
    method: 'GET',
    params,
  });
}

export async function getSectionsGradingSchemes(params) {
  return request('/api/gradeProtectionPrograms/getSectionsGradingSchemes', {
    method: 'GET',
    params,
  });
}

export async function fetchGradeProtectionProgramStudentDetails(params) {
  return request('/api/gradeProtectionPrograms/studentDetails', {
    method: 'GET',
    params,
  });
}

export async function addStudentNote(data) {
  return request('/api/gradeProtectionPrograms/addStudentEnrollmentNote', {
    method: 'POST',
    data,
  });
}

export async function updateTeachingResearchRemark(data) {
  return request('/api/gradingScheme/teachingResearchRemark', {
    method: 'POST',
    data,
  });
}